// extracted by mini-css-extract-plugin
export default {"infoBoxParagraph":"WidgetDocs_infoBoxParagraph__25UEj"};